// Disable max class per file due to form validation classes
/* eslint-disable max-classes-per-file */

import { IsInt, IsNotEmpty, IsString, ValidateNested } from 'class-validator';

export class TemplateForm {
  @IsInt()
  id: number;

  @IsString()
  @IsNotEmpty()
  name: string;
}

export class CreateAutodeskTemplateFileForm {
  @ValidateNested()
  template: TemplateForm;
}
